import React, {useContext, useEffect, useState} from "react";
import AppContext from "../../../store/AppContext";
import DominioRegistroService from "../../../services/RegistroDominioService";
import {TipoItemCarrito} from "../../../store/AppProvider";
import {useNavigate} from "react-router-dom";

export const ListaRegistroDominiosPasoUno = (props) => {
    const appCtx = useContext(AppContext);
    const carrito = appCtx.carrito.registrosPendientes;
    let uuidVenta = appCtx.venta.uuidVenta;
    const history = useNavigate();
    const [aniosPorExtension, setAniosPorExtension] = useState({});

    const extensionDesdeNombre = (nombreDominio) => {
        const m = (nombreDominio || '').match(/[.].*/);
        return m ? m[0] : '';
    };

    useEffect(() => {
        if (!carrito || carrito.length === 0) {
            return;
        }
        const extensiones = [...new Set(carrito.map((d) => extensionDesdeNombre(d.nombre)))];
        Promise.all(extensiones.map((ext) => DominioRegistroService.obtenerTarifas(ext))).then((responses) => {
            const map = {};
            extensiones.forEach((ext, idx) => {
                const tarifa = responses[idx];
                map[ext] = (tarifa && tarifa.aniosContratacion) ? tarifa.aniosContratacion : [1];
            });
            setAniosPorExtension(map);
        });
    }, [carrito]);

    const removeFromCarrito = (e)=> {
        e.preventDefault();
        const dominioIdRaw = e.currentTarget.id;
        appCtx.eliminarItemCarrito(dominioIdRaw, TipoItemCarrito.registro);
        if (appCtx.carrito.registrosPendientes.length === 1) {
            history("/consulta-disponibilidad");
        }

        const dominioId = Number(dominioIdRaw);
        if (!Number.isFinite(dominioId) || !uuidVenta) {
            return;
        }
        DominioRegistroService.eliminarRegistroDominio(dominioId, uuidVenta)
            .catch(() => {
                // Ignore
            });
    }

    return (
        <>
            {carrito == null || carrito.length === 0 ?
                <></> :
                <>
                    <table id="id-tabla-reg-dom" className="cart">
                        <caption>Registrar dominio</caption>
                        <thead>
                            <tr>
                                <th>Artículo</th>
                                <th>Duración</th>
                                <th className="tdright">Precio</th>
                            </tr>
                        </thead>
                        <tbody id="register_domains_tbody">
                            { carrito.map((dominio) => {
                                const anios = dominio.anios || 1;
                                const ext = extensionDesdeNombre(dominio.nombre);
                                const opciones = aniosPorExtension[ext] || [anios];
                                return (
                                <tr className="last" key={dominio.nombre}>
                                    <td>
                                    {/* eslint-disable-next-line */}
                                    <a className="close" id={dominio.id} onClick={ removeFromCarrito }></a>
                                    { dominio.nombre }
                                    </td>
                                    <td>
                                        <select name="anios-dominio" id={`id-anios-dominio-${dominio.id}`}
                                                value={anios} disabled={true}>
                                            {opciones.map((anio) => (
                                                <option key={anio} value={anio}>
                                                    {anio} {anio > 1 ? 'años' : 'año'}
                                                </option>
                                            ))}
                                        </select>
                                    </td>
                                    <td className="tdright">$ { dominio.precio * anios }</td>
                                </tr>
                                );
                            })}
                        </tbody>
                        <tfoot>
                            <tr>
                                <td></td>
                                <td className="tdright">Subtotal:</td>
                                <td className="price" id="id_shopping_cart_subtotal">$ {props.subTotal}</td>
                            </tr>
                        </tfoot>
                    </table>
                </>
            }
        </>
    );
}
